import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { TicketListingsSortPopover } from './TicketListingsSortPopover';
import { TicketViewTabs } from './TicketViewTabs';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useIsMobile } from '../hooks/useBreakpoint';
import styled from 'foundations-theming-specialty/utils';
import { MOBILE_BREAKPOINT } from '../constants';
import { ViewToggleSwitch } from './ViewToggleSwitch';
import { View } from 'foundations-components/components/View';
import { useTicketListingsSortAndFilters } from '../hooks/useTicketListingsSortAndFilters';
import { useTicketListingsHeading } from '../hooks/useTicketListingsHeading';
import { CreateTicketButton } from './CreateTicketButton';
import { TicketListingsSearchWithFilters } from './TicketListingsSearchWithFilters';
import { CsvExportButton } from './CsvExportButton';
import { MobileNavigationMenu } from './MobileNavigationMenu';
import { PageLinks } from './PageLinks';
import { usePageLinks } from '../hooks/usePageLinks';
import { usePortalData } from '../data/usePortalData';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterBarWrapper = styled.div.withConfig({
  displayName: "TicketListingsHeader__FilterBarWrapper"
})(["display:flex;flex-direction:column;align-items:stretch;justify-content:space-between;gap:", ";margin-block-start:", ";margin-block-end:", ";@media (min-width:", "px){flex-direction:row;align-items:center;flex-wrap:wrap;gap:", ";}"], ({
  theme
}) => theme.space[200], ({
  theme
}) => theme.space[400], ({
  theme
}) => theme.space[400], MOBILE_BREAKPOINT, ({
  theme
}) => theme.space[600]);
export function TicketListingsHeader({
  totalCount
}) {
  var _portalData$settings;
  const {
    view,
    setView
  } = useTicketListingsSortAndFilters();
  const isMobile = useIsMobile();
  const ticketListingsHeading = useTicketListingsHeading();
  const pageLinks = usePageLinks();
  const {
    data: portalData
  } = usePortalData();
  // Show the divider only when there are external links to separate from the
  // create-ticket button that now sits beside them.
  const showHeaderDivider = pageLinks.length > 0 && Boolean(portalData === null || portalData === void 0 || (_portalData$settings = portalData.settings) === null || _portalData$settings === void 0 ? void 0 : _portalData$settings.formGuid);
  if (isMobile) {
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "400",
      marginBlockEnd: "400",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h1",
          "data-test-id": "ticket-listings-heading",
          typography: "body-500",
          color: "text-core-default",
          children: ticketListingsHeading
        }), /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "400",
          children: [/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(CreateTicketButton, {})
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(CsvExportButton, {
              totalCount: totalCount
            })
          }), /*#__PURE__*/_jsx(MobileNavigationMenu, {})]
        })]
      }), /*#__PURE__*/_jsx(TicketListingsSearchWithFilters, {
        screen: "ticket-listings",
        inlineSize: "100%"
      }), /*#__PURE__*/_jsx(TicketViewTabs, {}), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          children: /*#__PURE__*/_jsx(TicketListingsSortPopover, {})
        }), /*#__PURE__*/_jsx(Text, {
          typography: "link-100",
          color: "text-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customer-portal-app.records",
            options: {
              count: totalCount || 0
            }
          })
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "space-between",
      paddingBlock: "25",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h1",
        typography: "heading-500",
        "data-test-id": "ticket-listings-heading",
        color: "text-core-default",
        children: ticketListingsHeading
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "400",
        children: [/*#__PURE__*/_jsx(PageLinks, {}), showHeaderDivider && /*#__PURE__*/_jsx(View, {
          blockSize: "20px",
          borderInlineStartWidth: "100",
          borderInlineStartStyle: "solid",
          borderColor: "border-core-subtle"
        }), /*#__PURE__*/_jsx(CreateTicketButton, {})]
      })]
    }), /*#__PURE__*/_jsx(TicketViewTabs, {}), /*#__PURE__*/_jsxs(FilterBarWrapper, {
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "400",
        children: [/*#__PURE__*/_jsx(TicketListingsSearchWithFilters, {
          screen: "ticket-listings",
          inlineSize: "370px",
          marginInlineEnd: "400"
        }), /*#__PURE__*/_jsx(TicketListingsSortPopover, {})]
      }), /*#__PURE__*/_jsxs(Flex, {
        gap: "600",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "link-100",
          color: "text-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            "data-test-id": "records-count",
            message: "customer-portal-app.records",
            options: {
              count: totalCount
            }
          })
        }), /*#__PURE__*/_jsx(ViewToggleSwitch, {
          view: view,
          onChange: setView
        }), /*#__PURE__*/_jsx(CsvExportButton, {
          totalCount: totalCount
        })]
      })]
    })]
  });
}